module.exports = __webpack_public_path__ + "static/media/milli1.ce160e8d.jpg";